import React, { useCallback, useEffect, useState } from 'react'

import Ui from '../../../ui'
import { hasText } from '../../../utils/helpers'
import ZentakeFormContext from '../ZentakeFormContext'

function MarkerQuestionFC({ question, isOfficeUse }) {
  const {
    isQuestionReadonly,
    isQuestionDirty,
    isQuestionValid,
    getAnswer,
    onAnswerChanged,
    getQuestionError,
  } = React.useContext(ZentakeFormContext)

  const [baseImage, setBaseImage] = useState(question?.image)
  const questionImage = question?.image
  useEffect(() => {
    setBaseImage(questionImage)
  }, [questionImage])

  const readonly = isQuestionReadonly(question)

  const isDirty = isQuestionDirty(question)
  const isValid = isQuestionValid(question)
  const questionError = getQuestionError(question)

  const [hasError, setHasError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(
    'This field is required'
  )

  React.useEffect(() => {
    setHasError(
      (isDirty && question?.is_required && !isValid) || hasText(questionError)
    )
    setErrorMessage(
      questionError && typeof questionError === 'string'
        ? questionError
        : 'This field is required'
    )
  }, [isDirty, question.is_required, isValid, questionError])

  const answer = getAnswer(question)

  const onReset = useCallback(() => {
    onAnswerChanged(question, null)
  }, [onAnswerChanged, question])

  const onChange = useCallback(
    async (markerImage) => {
      if (Array.isArray(markerImage)) {
        onAnswerChanged(
          question,
          markerImage.length > 0 ? markerImage[0] : null
        )
      } else {
        onAnswerChanged(question, markerImage)
      }
    },
    [onAnswerChanged, question]
  )

  return (
    <div>
      {question.text && (
        <Ui.QuestionTitle
          isOfficeUse={isOfficeUse}
          isRequired={question.is_required}
        >
          {question.text}
        </Ui.QuestionTitle>
      )}
      <Ui.ImageMarker
        imageBase={baseImage}
        imageMarkup={answer?.answer_raw}
        label={String(question.id)}
        onChange={onChange}
        onReset={onReset}
        readonly={readonly}
      />
      {hasError && (
        <div>
          <Ui.ErrorLabel label={errorMessage} />
        </div>
      )}
    </div>
  )
}

const MarkerQuestion = MarkerQuestionFC

export default MarkerQuestion
